import { LOGIN_SUCCESS, LOGOUT } from "./actionTypes";

export const loginAdmin = (data) => ({ type: LOGIN_SUCCESS, payload: data });

export const logout = () => {
  return { type: LOGOUT };
};
